<script>
    import { onMount } from "svelte";
    import { projects, apiDataDashboard, apiDataDashboard12975, apiDataDashboard12976, apiDataDashboard13003, apiDataDashboard13009, apiDataDashboard13013, apiDataDashboard13016, apiDataDashboard13011, apiDataDashboard13012, apiDataDashboard13024, apiDataDashboard13036, getDashboard } from './../services/store.js';

    import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
    import InSiteLayout from './InSiteLayout.svelte';
    import Dashboard from './dashboard/Dashboard.svelte';
    import ProjectSelector from "./dashboard/ProjectSelector.svelte";
    import Spinner from "./Spinner.svelte";


    const dashboardRequests = [
        {
            id : 13009,
            name : 'My SCF Projects',
            store : apiDataDashboard13009
        },
        {
            id : 13013,
            name : 'My Pre Construction Performance',
            store : apiDataDashboard13013
        },
        {
            id : 13016,
            name : 'My Construction Performance',
            store : apiDataDashboard13016
        },
        {
            id : 13011,
            name : 'My Legacy',
            store : apiDataDashboard13011
        },
        {
            id : 13012,
            name : 'My Lessons Learnt',
            store : apiDataDashboard13012
        },
        {
            id : 13024,
            name : 'My Bidders',
            store : apiDataDashboard13024
        },
    ];

    const baseURL = window.location.origin;
    const SCFAPIBase = baseURL + '/wp-json/scf-data/v1/';

    // Get the projects and put then in the store, this is used to populate the project selector.
    onMount(async () => {
        const nonce = scf_client_portal.nonce;
        const requestURL = SCFAPIBase + "get-projects/";
        fetch( requestURL, {
            headers: new Headers({
                'X-WP-Nonce': nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            projects.set(JSON.parse(data));
        }).catch((error, data) => {
            console.log('Tab Wrapper - Projects Request Error - ', error, data);
            return [];
        });
	});


	onMount(async () => {
        dashboardRequests.forEach(dashboardRequest => {
            getDashboard(dashboardRequest);
        });
    });

    const stringToKebabCase = (string) => {
        return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
    }
    

</script>

<Tabs>
    <TabList>
        {#each dashboardRequests as request}
            <Tab>{request.name}</Tab>
        {/each}
    </TabList>

    <TabPanel>
        {@const tabDashboardID = 13009}
        {@const dashboard = dashboardRequests.filter(dashboardRequest => dashboardRequest.id == tabDashboardID)[0]}
        <div class="dashboard {stringToKebabCase(dashboard.name)}">
            <ProjectSelector
                projects={$projects}
                dashboard={dashboard}
            />
            {#if $apiDataDashboard13009.data}
                <Dashboard
                    data={ $apiDataDashboard13009.data}
                    title={dashboard.name}
                />
            {:else}
                <p>{dashboard.name} Loading...</p>
                <Spinner />
            {/if}
        </div>
    </TabPanel>

    <TabPanel>
        {@const tabDashboardID = 13013}
        {@const dashboard = dashboardRequests.filter(dashboardRequest => dashboardRequest.id == tabDashboardID)[0]}
        <div class="dashboard {stringToKebabCase(dashboard.name)}">
            <ProjectSelector
                projects={$projects}
                dashboard={dashboard}
            />
            {#if $apiDataDashboard13013.data}
                <Dashboard
                    data={ $apiDataDashboard13013.data}
                    title={dashboard.name}
                />
            {:else}
                <p>{dashboard.name} Loading...</p>
                <Spinner />
            {/if}
        </div>
    </TabPanel>

    <TabPanel>
        {@const tabDashboardID = 13016}
        {@const dashboard = dashboardRequests.filter(dashboardRequest => dashboardRequest.id == tabDashboardID)[0]}
        <div class="dashboard {stringToKebabCase(dashboard.name)}">
            <ProjectSelector
                projects={$projects}
                dashboard={dashboard}
            />
            {#if $apiDataDashboard13016.data}
                <Dashboard
                    data={ $apiDataDashboard13016.data}
                    title={dashboard.name}
                />
            {:else}
                <p>{dashboard.name} Loading...</p>
                <Spinner />
            {/if}
        </div>
    </TabPanel>

    <TabPanel>
        {@const tabDashboardID = 13011}
        {@const dashboard = dashboardRequests.filter(dashboardRequest => dashboardRequest.id == tabDashboardID)[0]}
        <div class="dashboard {stringToKebabCase(dashboard.name)}">
            <ProjectSelector
                projects={$projects}
                dashboard={dashboard}
            />
            {#if $apiDataDashboard13011.data}
                <Dashboard
                    data={ $apiDataDashboard13011.data}
                    title={dashboard.name}
                />
            {:else}
                <p>{dashboard.name} Loading...</p>
                <Spinner />
            {/if}
        </div>
    </TabPanel>

    <TabPanel>
        {@const tabDashboardID = 13012}
        {@const dashboard = dashboardRequests.filter(dashboardRequest => dashboardRequest.id == tabDashboardID)[0]}
        <div class="dashboard {stringToKebabCase(dashboard.name)}">
            <ProjectSelector
                projects={$projects}
                dashboard={dashboard}
            />
            {#if $apiDataDashboard13012.data}
                <Dashboard
                    data={ $apiDataDashboard13012.data}
                    title={dashboard.name}
                />
            {:else}
                <p>{dashboard.name} Loading...</p>
                <Spinner />
            {/if}
        </div>
    </TabPanel>

    <TabPanel>
        {@const tabDashboardID = 13024}
        {@const dashboard = dashboardRequests.filter(dashboardRequest => dashboardRequest.id == tabDashboardID)[0]}
        <div class="dashboard {stringToKebabCase(dashboard.name)}">
            <ProjectSelector
                projects={$projects}
                dashboard={dashboard}
            />
            {#if $apiDataDashboard13024.data}
                <Dashboard
                    data={ $apiDataDashboard13024.data}
                    title={dashboard.name}
                />
            {:else}
                <p>{dashboard.name} Loading...</p>
                <Spinner />
            {/if}
        </div>
    </TabPanel>

</Tabs>

<style>
    .dashboard {
        position: relative;
    }

</style>